// Ortssuche für das Rent-Portal – ohne Google, ohne Kosten.
// 1) Vorschläge beim Tippen: lokale Liste aller deutschen Städte/Gemeinden (public/data/de-cities.json, GeoNames, CC BY 4.0)
// 2) Freie Adresse (z. B. "Frankfurt Münchner Straße 1"): EINE Abfrage beim Absenden über OpenStreetMap Nominatim
//    (Vorschläge beim Tippen sind dort laut Nutzungsbedingungen nicht erlaubt, eine Suche pro Klick schon).

let citiesPromise = null;

// Lädt die Städteliste einmal und hält sie im Speicher. Format je Eintrag: [Name, Bundesland, lat, lng, Großstadt-Rang (0 = keine)]
export const loadCities = () => {
  if (!citiesPromise) {
    citiesPromise = fetch(`${process.env.PUBLIC_URL || ""}/data/de-cities.json`)
      .then((r) => (r.ok ? r.json() : []))
      .catch(() => []);
  }
  return citiesPromise;
};

// Vergleich ohne Groß-/Kleinschreibung; ä/ae, ö/oe, ü/ue, ß/ss gelten als gleich
export const normalize = (value) =>
  value
    .toLowerCase()
    .replace(/ä/g, "ae")
    .replace(/ö/g, "oe")
    .replace(/ü/g, "ue")
    .replace(/ß/g, "ss")
    .replace(/[^a-z0-9]+/g, " ")
    .trim();

// Bis zu `limit` Vorschläge: erst Namen, die mit der Eingabe beginnen (Großstädte zuerst, dann kürzeste), dann Namen, die sie enthalten
export const suggestCities = (cities, query, limit = 8) => {
  const q = normalize(query);
  if (q.length < 2) return [];
  const starts = [];
  const contains = [];
  for (const c of cities) {
    const n = normalize(c[0]);
    if (n.startsWith(q)) starts.push(c);
    else if (contains.length < limit && n.includes(q)) contains.push(c);
  }
  const big = (c) => (c[4] ? c[4] : 1000);
  starts.sort((a, b) => big(a) - big(b) || a[0].length - b[0].length || a[0].localeCompare(b[0], "de"));
  return [...starts, ...contains].slice(0, limit).map((c) => ({
    label: c[0],
    detail: c[1],
    location: c[1] ? `${c[0]}, ${c[1]}` : c[0],
    lat: c[2],
    lng: c[3],
  }));
};

// Freitext (Adresse) in Koordinaten umwandeln – nur beim Absenden aufrufen
export const geocodeAddress = async (query) => {
  const url = `https://nominatim.openstreetmap.org/search?format=jsonv2&countrycodes=de&limit=1&accept-language=de&q=${encodeURIComponent(query)}`;
  const response = await fetch(url, { headers: { Accept: "application/json" } });
  if (!response.ok) return null;
  const results = await response.json();
  if (!results.length) return null;
  return { lat: Number(results[0].lat), lng: Number(results[0].lon), location: results[0].display_name };
};

// Entfernung zwischen zwei Punkten in Kilometern (Luftlinie)
export const distanceKm = (a, b) => {
  const rad = (d) => (d * Math.PI) / 180;
  const dLat = rad(b.lat - a.lat);
  const dLng = rad(b.lng - a.lng);
  const h = Math.sin(dLat / 2) ** 2 + Math.cos(rad(a.lat)) * Math.cos(rad(b.lat)) * Math.sin(dLng / 2) ** 2;
  return 2 * 6371 * Math.asin(Math.sqrt(h));
};

export const formatKm = (km) => (km < 1 ? `${Math.round(km * 1000)} m` : `${km.toLocaleString("de-DE", { maximumFractionDigits: 1 })} km`);

export const RADIUS_OPTIONS = [2, 5, 10];
